(function () {
  function initFaqAudio(section) {
    if (!section || section.dataset.faqAudioInitialized === 'true') return;
    section.dataset.faqAudioInitialized = 'true';
    var items = section.querySelectorAll('.faq-audio__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.faq-audio__question');
      var answer = item.querySelector('.faq-audio__answer');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (el) {
          el.classList.remove('is-open');
          var otherButton = el.querySelector('.faq-audio__question');
          var otherAnswer = el.querySelector('.faq-audio__answer');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
          if (otherAnswer) otherAnswer.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-faq-audio]').forEach(initFaqAudio); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
